import { Typography } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledFooterLinkText = styled(Typography)(({ theme }) => ({
  fontFamily: 'General Sans',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '150%',
  letterSpacing: '0.03em',
  textTransform: 'none',
  color: theme.palette.text.main,
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  whiteSpace: 'normal',
  maxWidth: theme.typography.pxToRem(220),
  [theme.breakpoints.down('sm')]: {
    maxWidth: theme.typography.pxToRem(140),
  },
}));
